export default String.raw`
<g id="Banner 1440 px">
    <rect width="1440" height="396" class="bgColor"/>
    <g id="Banner + indicator">
        <g id="Frame 223">
            <image clip-path="inset(0% round 12px)" preserveAspectRatio="xMidYMid slice" width="1180" height="320" x="130" y="32"  href="./img/previewElements/mainBanner-new.png" />
            <rect width="536" height="212" x="198" y="86" rx="8" class="bannerTextFieldColor"/>
            <g id="Frame 221">
                <g id="Frame 226">
                    <text class="bannerFontColor" xml:space="preserve" style="white-space: pre" font-size="36" font-weight="bold" letter-spacing="0px"><tspan x="230" y="151.091">TRANSLATION_Prv_MainBannerA_TextA</tspan></text>
                    <text class="bannerSecondaryFontColor" xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="230" y="192.545">TRANSLATION_Prv_SeeForYourself</tspan></text>
                </g>
                <g id="Primary button">
                    <rect x="230" y="230" width="277" height="36" rx="5" class="bannerBtnBgColor"/>
                    <text id="Button" class="bannerBtnFontColor" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="343.275" y="253.091">TRANSLATION_Prv_Look</tspan></text>
                </g>
            </g>
        </g>
        <g id="Indicators">
            <g id="Arrow/indicator">
                <rect id="Rectangle 167" x="641" y="360" width="32" height="4" rx="1" class="lighterColor"/>
            </g>
            <g id="Arrow/indicator_2">
                <rect id="Rectangle 167_2" x="683" y="360" width="32" height="4" rx="1" class="secondaryColor"/>
            </g>
            <g id="Arrow/indicator_3">
                <rect id="Rectangle 167_3" x="725" y="360" width="32" height="4" rx="1" class="lighterColor"/>
            </g>
            <g id="Arrow/indicator_4">
                <rect id="Rectangle 167_4" x="767" y="360" width="32" height="4" rx="1" class="lighterColor"/>
            </g>
        </g>
    </g>
    <g id="Arrow" filter="url(#filter_mainBanner_1_1)">
        <g id="Arrows/chevron right">
            <rect x="1286" y="174" width="48" height="48" rx="4" class="secondaryBtnBgColor"/>
            <use class="secondaryBtnFontColor" transform="translate(1304, 191)" href="#chevron-right" width="16" height="16"></use>
        </g>
    </g>
    <g id="Arrow_2" filter="url(#filter_mainBanner_1_2)">
        <g id="Arrows/chevron left">
            <rect x="106" y="174" width="48" height="48" rx="4" class="secondaryBtnBgColor"/>
            <use class="secondaryBtnFontColor" transform="translate(122, 191)" href="#chevron-left" width="16" height="16"></use>
        </g>
    </g>
</g>
<defs>
    <filter id="filter_mainBanner_1_1" x="1282" y="170" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1744_306412"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1744_306412" result="shape"/>
    </filter>
    <filter id="filter_mainBanner_1_2" x="102" y="170" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1744_306412"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1744_306412" result="shape"/>
    </filter>
</defs>
`;